import { axios } from '@Root/API'

export const getAll = payload => {
	return axios.get('additional-field', { params: payload })
}
